import { Component, inject } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Store } from '@ngxs/store';
import { UserNamePipeModule } from '@wilson/account';
import { CommonModule } from '@angular/common';
import {
  OrganizationalUnitHelperService,
  OrganizationalUnitsState,
  OrgUnitNamePipeModule,
} from '@wilson/organizational-unit';
import { Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'wilson-employee-org-unit-name-renderer',
  imports: [
    CommonModule,
    UserNamePipeModule,
    OrgUnitNamePipeModule,
    TranslateModule,
    NzTagModule,
    FontAwesomeModule,
  ],
  template: `
    @if (isLoading$ | async) {
      <nz-tag class="rounded-0" nzColor="processing">
        <fa-icon [icon]="faSpinner" class="me-1" [spin]="true"></fa-icon>
        <span>{{ 'general.loading' | translate }}</span>
      </nz-tag>
    } @else {
      <div>
        <div class="text-dark text-truncate">
          {{ orgUnitName$ | async }}
        </div>
      </div>
    }
  `,
})
export class EmployeeOrgUnitNameRendererComponent
  implements AgRendererComponent
{
  private store = inject(Store);
  private organizationalUnitHelperService = inject(
    OrganizationalUnitHelperService,
  );

  protected faSpinner = faSpinner;
  protected isLoading$: Observable<boolean> = this.store.select(
    OrganizationalUnitsState.isLoading,
  );
  protected orgUnitName$!: Observable<string | undefined>;

  agInit(params: ICellRendererParams): void {
    this.getValueToDisplay(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.getValueToDisplay(params);
    return true;
  }

  getValueToDisplay(params: ICellRendererParams): void {
    this.orgUnitName$ = this.organizationalUnitHelperService.getOrgUnitNameById(
      params.value,
      false,
    );
  }
}
